// extracted by mini-css-extract-plugin
module.exports = {"OmniChannelFormWrapper":"OmniChannel_OmniChannelFormWrapper__k57VE"};